<template>
  <div>
    <el-row>
      <el-col class="box" :span="24">
        <div class="list__header">
          <router-link :to="addRoute" v-if="addRoute">
            <el-button type="primary" class="fluid">
              Dodaj {{ verboseName }} <i class="el-icon-plus"></i>
            </el-button>
          </router-link>

          <p class="list__title">
            {{ getRouteName($route) }}
          </p>
          <search-list-form
            v-model="filters.selected.search"
            @submit="debouncedFetchData"
            v-if="includeSearchFilter"
          />
        </div>
        <el-row class="header__actions">
          <el-col>
            <component-compiler
              v-for="(component, i) in headerActions()"
              class="margin-right-15"
              :content="component"
              :key="`header-action-${i}`"
            />
          </el-col>
        </el-row>
        <div class="grid">
          <div class="item" v-for="video in items" :key="video.id">
            <el-card style="margin-bottom: 20px; position: relative">
              <router-link :to="getEditRoute(video)">
                <div class="video__wrapper">
                  <img
                    v-if="video.poster_url"
                    class="video-thumbnail"
                    :src="video.poster_url"
                    :alt="video.title"
                  />
                  <video
                    v-else
                    class="video-thumbnail"
                    :src="video.file_url"
                    preload="metadata"
                    muted
                  />
                </div>
                <el-link>{{ video.title }}</el-link>
              </router-link>
              <el-button
                @click.stop="handleDelete(null, video)"
                class="remove-button"
                circle
                size="mini"
                icon="el-icon-delete"
                type="danger"
                title="Usuń wideo"
              >
              </el-button>
            </el-card>
          </div>
        </div>
        <el-row>
          <el-col :span="24" class="list__pagination">
            <pagination
              layout="prev, pager, next"
              @page-change="handlePageChange"
              :current-page="page"
              :total-pages="Math.ceil(count / pageSize)"
            >
            </pagination>
          </el-col>
        </el-row>
        <el-row>
          <el-row>
            <el-col>
              <component-compiler
                v-for="(component, i) in footerActions()"
                class="margin-right-15"
                :content="component"
                :key="`list-action-${i}`"
              />
            </el-col>
          </el-row>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { Video } from '@/api'
import ListMixin from '@/crudBases/list/ListMixin'

export default {
  mixins: [ListMixin],
  data() {
    return {
      editRouteName: 'Edit Video',
      addRoute: { name: 'Add Video' },
      verboseName: 'Wideo',
      verboseNamePlural: 'Wideo',
      listFields: [
        { label: 'wideo', type: 'video', prop: 'file_url' },
        { prop: 'title', label: 'tytuł' }
      ]
    }
  },
  computed: {
    service() {
      return Video
    }
  }
}
</script>

<style lang="scss" scoped>
.video-thumbnail {
  max-width: 100%;
  max-height: 100%;
  transition: 0.3s all;
  object-fit: cover;

  &__wrapper {
    overflow: hidden;
    text-align: center;
    height: 130px;
    margin-bottom: 10px;
  }

  &:hover {
    transform: scale(1.05);
  }
}

.video__wrapper {
  overflow: hidden;
  text-align: center;
  height: 130px;
  margin-bottom: 10px;
}

.remove-button {
  position: absolute;
  top: 0;
  right: 0;
}

.grid {
  display: grid;
  grid-column-gap: 20px;
  grid-row-gap: 20px;
  grid-template-columns: repeat(4, 1fr);
}
</style>
